module.exports = __webpack_public_path__ + "static/img/banner_02.12aba2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_02.jpg
// module id = DWqi
// module chunks = 9